import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {tagsModel} from "@/app/templates";
import {IconFont} from "@/lib/util";
import SlideView from "@/components/SlideView.vue";
import {computed, onMounted, onUpdated, reactive, watch} from "vue";
import {MenuInfo} from "ant-design-vue/es/menu/src/interface";
import {useRoute, useRouter} from "vue-router";

interface IQuery {
  [key: string]: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitiesSide',
  setup(__props) {


const tagsStatus = {
  's_pre': '未开始',
  's_progress': '进行中',
  's_timeout': '已结束'
}

const info = reactive({
  show: true,
  menu: {
    toggle: false,
    groups: {model: '', status: ''} as IQuery
  }
})
const route = useRoute()
const router = useRouter()

onMounted(() => {
  info.show = route.path == '/activities'
  watch(() => route.path, p => {
    info.show = p == '/activities'
  })
  initQuery()
})

onUpdated(() => {
  initQuery()
})

const initQuery = () => {
  info.menu.groups.model = typeof route.query.model == 'string' ? route.query.model : ''
  info.menu.groups.status = typeof route.query.status == 'string' ? route.query.status : ''
}

const model = computed(() => {
  const arr = []
  if (info.menu.groups.model) arr.push(info.menu.groups.model)
  if (arr.length == 0) arr.push('')
  return arr
})
const status = computed(() => {
  const arr = []
  if (info.menu.groups.status) arr.push(info.menu.groups.status)
  if (arr.length == 0) arr.push('')
  console.log('status', info.menu.groups.status)
  return arr
})
const onSelect = (mi: MenuInfo) => {
  if (mi.key == '') info.menu.groups[mi.item.group] = ''
  else info.menu.groups[mi.item.group] = mi.key as string
  doRoute(JSON.parse(JSON.stringify(info.menu.groups)))
}

const onDeselect = (mi: MenuInfo) => {
  info.menu.groups[mi.item.group] = ''
  doRoute(JSON.parse(JSON.stringify(info.menu.groups)))
}

const doRoute = (query: IQuery) => {
  delete query.toggle
  for (let key in query) {
    if (query[key] == '') delete query[key]
  }
  router.push({path: '/activities', query})
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_item_group = _resolveComponent("a-menu-item-group")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (info.show)
    ? (_openBlock(), _createBlock(SlideView, {
        key: 0,
        toggle: info.menu.toggle,
        "onUpdate:toggle": _cache[2] || (_cache[2] = ($event: any) => ((info.menu.toggle) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            "inline-collapsed": info.menu.toggle,
            "selected-keys": model.value,
            "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
            onSelect: onSelect,
            onDeselect: onDeselect
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item_group, { title: "裂变玩法" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, {
                    key: "",
                    group: "model"
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(IconFont), { type: "icon-quanbu" })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 全部 ")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagsModel), (f, k) => {
                    return (_openBlock(), _createBlock(_component_a_menu_item, {
                      key: k,
                      group: "model"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(IconFont), {
                          type: `icon-${k}`
                        }, null, 8, ["type"])
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(f), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_divider)
            ]),
            _: 1
          }, 8, ["inline-collapsed", "selected-keys"]),
          _createVNode(_component_a_menu, {
            "inline-collapsed": info.menu.toggle,
            "selected-keys": status.value,
            "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((status).value = $event)),
            onSelect: onSelect
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item_group, { title: "活动状态" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, {
                    key: "",
                    group: "status"
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(IconFont), { type: "icon-quanbu" })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 全部 ")
                    ]),
                    _: 1
                  }),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tagsStatus, (f, k) => {
                    return _createVNode(_component_a_menu_item, {
                      key: k,
                      group: "status"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(IconFont), {
                          type: `icon-status-${k.replace('s_','')}`
                        }, null, 8, ["type"])
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(f), 1)
                      ]),
                      _: 2
                    }, 1024)
                  }), 64))
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_divider)
            ]),
            _: 1
          }, 8, ["inline-collapsed", "selected-keys"])
        ]),
        _: 1
      }, 8, ["toggle"]))
    : _createCommentVNode("", true)
}
}

})